"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewportConstrainedDomWrapper = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_1 = require("react");
var Declarative_1 = require("./Declarative");
var ViewportHelpers = require("./ViewportHelpers");
/**
 * Wraps a component in a container that will size intelligently to its contents and the viewport. The size constraints
 * are determined once when the component is constructed and need to be manually updated with updateSize().
 *
 * The default behavior is to allow its children to determine the container size, but when
 * (a) zoomed out, restrict the container size to be less than the visual viewport size or
 * (b) zoomed in/no zoom, restrict the container size to be less than the page's initial containing block
 */
var ViewportConstrainedDomWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(ViewportConstrainedDomWrapper, _super);
    function ViewportConstrainedDomWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.state = _this.getStateForCurrentViewport();
        return _this;
    }
    ViewportConstrainedDomWrapper.prototype.getStateForCurrentViewport = function () {
        var visualViewport = ViewportHelpers.getVisualViewport();
        return {
            visualViewportSize: {
                width: visualViewport.width,
                height: visualViewport.height
            },
            layoutViewportSize: ViewportHelpers.getLayoutViewportSize()
        };
    };
    ViewportConstrainedDomWrapper.prototype.getMaxSize = function () {
        /**
         * Generally we want the element to be no larger than the visual viewport.
         * But when zoomed in, the contents may get squished as a result if we limit the size purely on the visual viewport.
         * If a min-width/min-height value is set on the wrapper we assume that this case has been handled, otherwise we
         * set a floor value on max-width/max-height.
         */
        var baseMaxSize = { width: this.state.visualViewportSize.width, height: this.state.visualViewportSize.height };
        var isMinWidthSpecified = this.props.style && this.props.style.minWidth;
        if (!isMinWidthSpecified) {
            baseMaxSize.width = Math.max(baseMaxSize.width, this.state.layoutViewportSize.width);
        }
        var isMinHeightSpecified = this.props.style && this.props.style.minHeight;
        if (!isMinHeightSpecified) {
            baseMaxSize.height = Math.max(baseMaxSize.height, this.state.layoutViewportSize.height);
        }
        if (this.props.horizontalMargins) {
            baseMaxSize.width -= this.props.horizontalMargins;
        }
        if (this.props.verticalMargins) {
            baseMaxSize.height -= this.props.verticalMargins;
        }
        return baseMaxSize;
    };
    /**
     * Updates size so that the size constraints reflect the current viewport size. Triggers a re-render.
     */
    ViewportConstrainedDomWrapper.prototype.updateSize = function () {
        this.setState(this.getStateForCurrentViewport());
    };
    ViewportConstrainedDomWrapper.prototype.render = function () {
        var maxSize = this.getMaxSize();
        var divProps = {
            style: tslib_1.__assign(tslib_1.__assign({ maxWidth: maxSize.width, maxHeight: maxSize.height }, this.props.style), Declarative_1.conditional(this.props.isMaximized, { width: maxSize.width, height: maxSize.height })),
            'data-tb-test-id': this.props.testId
        };
        return react_1.createElement('div', divProps, this.props.children);
    };
    return ViewportConstrainedDomWrapper;
}(React.Component));
exports.ViewportConstrainedDomWrapper = ViewportConstrainedDomWrapper;
//# sourceMappingURL=ViewportConstrainedDom.js.map